import { Navigate } from 'react-router-dom';
import { type ReactNode } from 'react';
import { usePermissions } from '../hooks/usePermissions.ts';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

export default function AdminRoute({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { isAdmin, loading } = usePermissions();

  if (loading) {
    return (
      <div
        style={{
          background: '#fff',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <Spin fullscreen tip={t('common.checking-permissions')} size="large" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
